import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M75.0809 41.1669C75.0809 41.1669 61.5208 34.2768 57.4708 29.5468C52.9708 24.2868 53.1708 1.64685 53.1708 1.64685H40.7509C40.7509 1.64685 41.0608 24.3968 36.4508 29.5468C31.5608 35.0068 18.8408 40.9669 18.8408 40.9669C25.0308 55.5469 37.4308 59.2669 46.9608 59.2669C56.4908 59.2669 68.8909 55.7468 75.0809 41.1669Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M88.6106 58.0668C86.8806 46.0768 83.4006 42.8168 78.7306 40.4668C76.2206 39.1968 61.6406 31.6268 61.6406 31.6268L56.2906 25.6068L46.9606 30.4668L37.6306 25.6068L32.2806 31.6268C32.2806 31.6268 17.7007 39.1968 15.1907 40.4668C10.5207 42.8168 6.96067 46.4468 5.31067 58.0668C3.61067 69.9868 3.39062 71.8868 3.39062 71.8868H90.5406C90.5306 71.8768 90.3706 70.3168 88.6106 58.0668Z"
        fill="white"
        stroke="#D3D3D3"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M47.5805 43.6168L50.4305 37.4169L47.0005 31.1469L43.4905 37.4169L46.3305 43.6168L42.0605 70.8269H51.8505L47.5805 43.6168Z"
        fill={secondaryFill}
      />
      <path d="M32.1602 31.6269L41.7502 40.7969L46.7802 30.1569" stroke="#D3D3D3" strokeMiterlimit="10" fill="white" />
      <path d="M61.7499 31.6269L52.1699 40.7969L47.1299 30.1569" stroke="#D3D3D3" strokeMiterlimit="10" fill="white" />
      <path
        d="M32.7904 30.5868L46.8704 71.6968H2.15039C2.15039 71.6968 7.15039 46.5168 8.15039 44.9868C9.15039 43.4568 32.7904 30.5868 32.7904 30.5868Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M28.6307 32.6868L27.8008 52.3768L33.2908 54.6768L30.4608 61.1768L38.9608 71.8768"
        stroke={outline}
        fill="none"
        strokeMiterlimit="10"
      />
      <path
        d="M61.4404 30.5868L47.3604 71.6968H92.0804C92.0804 71.6968 87.0804 46.5168 86.0804 44.9868C85.0804 43.4468 61.4404 30.5868 61.4404 30.5868Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M65.6003 32.6868L66.4403 52.3768L60.9403 54.6768L63.7703 61.1768L55.2803 71.8768"
        stroke={outline}
        fill="none"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="46.9563"
          y1="43.6068"
          x2="46.9563"
          y2="4.74325"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
